/* Wander Painting mega menu: hover intent, touch (tap to open, tap again to go), keyboard, Esc. */
class WpMegaMenu extends HTMLElement {
  connectedCallback() {
    this.items = Array.from(this.querySelectorAll('.wp-mega__item--has-panel'));
    this.openItem = null;
    this.timer = null;
    this.lastPointer = 'mouse';

    this.items.forEach((item) => {
      const top = item.querySelector('.wp-mega__top');

      item.addEventListener('pointerenter', (e) => {
        this.lastPointer = e.pointerType;
        if (e.pointerType !== 'mouse') return;
        this.schedule(() => this.open(item), this.openItem ? 0 : 90);
      });
      item.addEventListener('pointerleave', (e) => {
        if (e.pointerType !== 'mouse') return;
        this.schedule(() => this.close(item), 200);
      });

      top.addEventListener('pointerdown', (e) => (this.lastPointer = e.pointerType));
      top.addEventListener('click', (e) => {
        // Touch / pen: first tap opens the panel, second tap follows the link.
        if (this.lastPointer !== 'mouse' && this.openItem !== item) {
          e.preventDefault();
          this.open(item);
        }
      });

      top.addEventListener('keydown', (e) => {
        if ((e.key === 'ArrowDown' || e.key === ' ') && this.openItem !== item) {
          e.preventDefault();
          this.open(item);
          const first = item.querySelector('.wp-mega__panel a');
          if (first) first.focus();
        }
      });

      item.addEventListener('focusout', (e) => {
        if (!item.contains(e.relatedTarget)) this.close(item);
      });
    });

    this.onKeyup = (e) => {
      if (e.key !== 'Escape' || !this.openItem) return;
      const top = this.openItem.querySelector('.wp-mega__top');
      this.close(this.openItem);
      top.focus();
    };
    this.onDocClick = (e) => {
      if (this.openItem && !this.contains(e.target)) this.close(this.openItem);
    };
    this.lastScroll = window.scrollY;
    this.onScroll = () => {
      if (this.openItem && Math.abs(window.scrollY - this.lastScroll) > 80) this.close(this.openItem);
      if (!this.openItem) this.lastScroll = window.scrollY;
    };

    document.addEventListener('keyup', this.onKeyup);
    document.addEventListener('click', this.onDocClick);
    window.addEventListener('scroll', this.onScroll, { passive: true });
  }

  disconnectedCallback() {
    document.removeEventListener('keyup', this.onKeyup);
    document.removeEventListener('click', this.onDocClick);
    window.removeEventListener('scroll', this.onScroll);
  }

  schedule(fn, delay) {
    clearTimeout(this.timer);
    this.timer = setTimeout(fn, delay);
  }

  // Anchor a dropdown under its menu item, kept inside the viewport (wide panels span the header).
  position(item) {
    const panel = item.querySelector('.wp-mega__panel');
    if (!panel || panel.classList.contains('wp-mega__panel--wide')) return;
    const wrapper = this.closest('.header-wrapper') || document.body;
    const wrapRect = wrapper.getBoundingClientRect();
    const itemRect = item.getBoundingClientRect();
    const gutter = 16;
    const width = panel.offsetWidth;
    let left = itemRect.left - wrapRect.left;
    left = Math.min(left, wrapRect.width - width - gutter);
    left = Math.max(left, gutter);
    panel.style.setProperty('--wp-panel-left', `${Math.round(left)}px`);
  }

  open(item) {
    clearTimeout(this.timer);
    if (this.openItem && this.openItem !== item) this.close(this.openItem);
    this.position(item);
    item.classList.add('is-open');
    item.querySelector('.wp-mega__top').setAttribute('aria-expanded', 'true');
    this.openItem = item;
    this.lastScroll = window.scrollY;
  }

  close(item) {
    item.classList.remove('is-open');
    item.querySelector('.wp-mega__top').setAttribute('aria-expanded', 'false');
    if (this.openItem === item) this.openItem = null;
  }
}

if (!customElements.get('wp-mega-menu')) customElements.define('wp-mega-menu', WpMegaMenu);
